export enum LayoutPartName {
  leftSidebar = 'leftSidebar',
  main = 'main',
  rightSidebar = 'rightSidebar',
}
